import React from 'react';
import { CRM_COLORS } from '../theme/crmColors';
import { thresholds, redirect_to_thresholds } from './paths';
import Authentication from '../components/auth/Authentication';
import { User } from '../utils/types';
import { useSelector } from 'react-redux';
import { CustomReducerState } from '../redux/reducers';
import ThresholdsList from '../components/thresholds/list';
import { Box } from '@material-ui/core';
import IntegratedHeader from '../components/header/IntegratedHeader';
import { useTranslate } from 'react-admin';

const ThresholdsPage = () => {
    const userConnected: User | null = useSelector((state: CustomReducerState) => state.rikutec.users.userConnected);
    const translate = useTranslate();

    return (
        <Authentication redirectTo={redirect_to_thresholds}>
            {userConnected && (
                <Box
                    style={{
                        height: '100vh',
                        display: 'grid',
                        gridTemplateRows: 'auto 1fr',
                        backgroundColor: CRM_COLORS.background,
                    }}
                >
                    <IntegratedHeader
                        currentPath={thresholds}
                        eyebrow={translate('app.headers.eyebrow.reference')}
                        title={translate('app.headers.thresholds')}
                    />

                    <Box
                        style={{
                            overflowY: 'auto',
                            minHeight: 0,
                            height: '100%',
                        }}
                    >
                        <ThresholdsList />
                    </Box>
                </Box>
            )}
        </Authentication>
    );
};

export default ThresholdsPage;
